import styled from "styled-components";

import { info as navBarInfo } from "@components/Navigation/NavBar";

export const Root = styled.section`
  position: relative;
  min-height: calc(100vh - var(${navBarInfo.cssVarHeaderHeight}));
  width: 100%;
  padding-top: ${props => props.theme.spacing.spacing_32};
  padding-bottom: ${props => props.theme.spacing.spacing_40};
  overflow-x: clip;
  overflow-y: visible;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: ${props => props.theme.spacing.spacing_32};

  ${props => props.theme.breakpointsV2.largeMobile} {
    justify-content: flex-end;
  }

  ${props => props.theme.breakpointsV2.smallTablet} {
    padding-top: ${props => props.theme.spacing.spacing_48};
    padding-bottom: ${props => props.theme.spacing.spacing_64};
    justify-content: center;
  }

  ${props => props.theme.breakpointsV2.smallDesktop} {
    padding-top: ${props => props.theme.spacing.spacing_64};
    padding-bottom: ${props => props.theme.spacing.spacing_80};
  }
`;

export const FakeServiceSelector = styled.div`
  width: 100%;
  height: 300px;
  background: #fff;
  border-radius: 8px;

  ${props => props.theme.breakpointsV2.smallTablet} {
    height: 150px;
  }
`;

export const IconContainer = styled.div`
  position: absolute;
  inset: 0;
  overflow: hidden;
  z-index: -1;
`;

export const BoltIcon = styled.svg`
  position: absolute;
  top: -263px;
  left: -431px;
  width: 943px;
  transform: rotate(166deg);
  z-index: -1;
  fill: ${props => props.theme.palette.blue500};

  ${props => props.theme.breakpointsV2.smallTablet} {
    top: -318px;
    left: -603px;
    width: 1500px;
    transform: rotate(162deg);
  }

  ${props => props.theme.breakpointsV2.smallDesktop} {
    top: -432px;
    left: -800px;
    width: 1942px;
    transform: rotate(162deg);
  }
`;

export const BackgroundImage = styled.figure`
  all: unset;

  position: absolute;
  inset: 0;
  z-index: -2;

  background-color: #067958;
`;
